import { Link } from "react-router-dom";

export default function SeriesNavigation({ items, currentSlug, basePath }) {
  const currentIndex = items.findIndex(item => item.slug === currentSlug);
  const nextIndex = (currentIndex + 1) % items.length;
  const nextItem = items[nextIndex];

  return (
    <div className="mt-12 pt-48 flex justify-end">
      <div className="text-right">
        <div className="text-center text-[2rem] leading-[3rem] mb-4">Continue to</div>
        <Link 
          to={`${basePath}/${nextItem.slug}`}
          className="flex items-center gap-4 hover:opacity-80 transition-opacity group"
        >
          <div className="text-right">
            <div className="text-[#C3EEFD] text-[2.4rem] md:text-[2.8rem] leading-[3.2rem] tracking-[.08rem] group-hover:text-primary-red transition-colors font-medium">
              {nextItem.name}
            </div>
            <span className="text-[1.8rem] leading-[2.5rem] text-gray-300">
              {nextItem.category}
            </span>
          </div>
          <div className="w-32 h-[2px] bg-primary-red group-hover:bg-white transition-colors"></div>
        </Link>
      </div>
    </div>
  );
}